<p-card [header]="heading" styleClass="border-round-xl m-8 mt-2 shadow-6" *ngIf="tester && tester.address">
    <app-tester [tester]="tester" [showBackButton]="false"></app-tester>
</p-card>